import {
  Button,
  Cascader,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  TreeSelect,
  TreeSelectProps,
} from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { pageSupplier, selectSupplierdata } from '../wms/supplierSlice'
import { commodityPageParams } from '../../services/commodity'
import { getOtcCategoryName, OtcCategories } from '../../models/Otccategory'
import { setCurrent } from './commoditySlice'
import styles from './Commodity.module.css'
import {
  getMaterialsCategoryName,
  getMaterialsName,
  Materiales,
  MaterialsCategories,
} from '../../models/commodity'
import {
  selectInsuranceArray,
  selectTenantName,
} from '../../app/applicationSlice'
import { DefaultOptionType } from 'antd/lib/select'
import {
  getCodeCompletions,
  getCommonCodeCompletionsAsync,
} from '../completion/completionSlice'
import { CommonCodeCategory } from '../../models/commoncode'
import { RootDispatch } from '../../app/store'
import { unwrapResult } from '@reduxjs/toolkit'
import { FilterIconOutlined } from '../../compnents/icons/Icons'
import { ThemeContext } from '../../theme/ThemeContext'
import { DateTimeFormat, DateTimeFormatSimpleOnlyOne } from '../../models/datetime'
import moment from 'moment'

const { Option } = Select

const { TreeNode } = TreeSelect

const { RangePicker } = DatePicker

export const Commodityquery = (props: {
  loading?: any
  onValueChange: (queries: commodityPageParams) => void
}) => {
  const [form] = Form.useForm()

  const [popoverForm] = Form.useForm()

  const [open, setOpen] = useState(false)

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const tenantName = useSelector(selectTenantName)

  const data = useSelector(selectSupplierdata)

  const insuranceArray = useSelector(selectInsuranceArray)

  const [treeData, setTreeData] = useState<any>([])

  const getYPFL = () => {
    const data = Materiales.map((v) => {
      return {
        id: v,
        value: v.toString(),
        label: getMaterialsName(v),
        children: [],
      }
    })

    dispatch(
      getCommonCodeCompletionsAsync({
        category: CommonCodeCategory.Durg,
        keyword: '',
      })
    )
      .then(unwrapResult)
      .then((res) => {
        const tree = data.map((v) => {
          if (v.id == 0) {
            return {
              ...v,
              children: res.records.map((el: any) => ({
                value: el.codeName,
                label: el.codeName,
              })),
            }
          } else if (v.id == 1) {
            return {
              ...v,
              children: [
                { value: '材料', label: '材料' },
                { value: '器械', label: '器械' },
                { value: '消耗品', label: '消耗品' },
                { value: '其他', label: '其他' },
              ],
            }
          } else if (v.id == 2) {
            return {
              ...v,
              children: [
                { value: '第一类医疗器械', label: '第一类医疗器械' },
                { value: '第二类医疗器械', label: '第二类医疗器械' },
                { value: '第三类医疗器械', label: '第三类医疗器械' },
              ],
            }
          } else if (v.id == 4) {
            return {
              ...v,
              children: [
                { value: '食品', label: '食品' },
                { value: '化妆品', label: '化妆品' },
                { value: '保健品', label: '保健品' },
                { value: '卫生消毒用品', label: '卫生消毒用品' },
                { value: '初级农产品', label: '初级农产品' },
                { value: '其他产品', label: '其他产品' },
              ],
            }
          } else {
            return v
          }
        })

        setTreeData(tree)
      })
  }

  useEffect(() => {
    if (insuranceArray.length) {
      form.setFieldsValue({
        insuranceCode: insuranceArray[0].insuranceCode,
      })
    }
  }, [insuranceArray])

  const dataParams = JSON.parse(sessionStorage.getItem('/commodity') || '{}')

  useEffect(() => {
    getYPFL()
    dispatch(pageSupplier({ supplierCategory: 1, size: 20 }))
    if (Object.keys(dataParams).length) {
      form.setFieldsValue({
        ...dataParams,
        materialsCategory: dataParams?.materialsCategoryList,
      })
      popoverForm.setFieldsValue({
        chrgitmLvs: dataParams?.chrgitmLvs ? dataParams?.chrgitmLvs?.split(',') : [],
        anaesthesiaTag: dataParams?.anaesthesiaTag ? true : false,
        antibioticTag: dataParams?.antibioticTag ? true : false,
        basicMedicineTag: dataParams?.basicMedicineTag ? true : false,
        natNegoDrugFlag: dataParams?.natNegoDrugFlag ? true : false,
        provinceTendFlag: dataParams?.provinceTendFlag ? true : false,
        showFlag: dataParams?.showFlag === 1 ? ['0','1'] : dataParams?.showFlag === 0 ? ['0'] : dataParams?.showFlag === 2 ? ['1'] : [],
        isLimitPrice: dataParams?.isLimitPrice == 1 ? ['1'] : dataParams?.isLimitPrice === 0 ? ['0'] : dataParams?.isLimitPrice === 2 ? ['0','1'] : [],
        gtPrice: dataParams?.gtPrice === 1 ? ['1'] : [],
        ltPrice: dataParams?.ltPrice === 1 ? ['1'] : [],
        eqPrice: dataParams?.eqPrice === 1 ? ['1'] : [],
        ltCostPrice: dataParams?.ltCostPrice === 1 ? ['1'] : [],
        gtCostPrice: dataParams?.gtCostPrice === 1 ? ['1'] : [],
        eqCostPrice: dataParams?.eqCostPrice === 1 ? ['1'] : [],
        complexPrice: dataParams?.complexPrice === 1 ? ['1'] : [],
        lastUpdateTime: dataParams?.lastUpdateTimeStart
          ? [moment(dataParams?.lastUpdateTimeStart), moment(dataParams?.lastUpdateTimeEnd)]
          : [],
        })
    }
    form.submit()
  }, [])

  const refresh = () => {
    const category = form.getFieldsValue()?.materialsCategory
    const showFlagValue: any = popoverForm.getFieldsValue()?.showFlag
    const isLimitPriceValue: any = popoverForm.getFieldsValue()?.isLimitPrice
    const gtPrice: any = popoverForm.getFieldsValue()?.gtPrice
    const ltPrice: any = popoverForm.getFieldsValue()?.ltPrice
    const eqPrice: any = popoverForm.getFieldsValue()?.eqPrice
    const ltCostPrice: any = popoverForm.getFieldsValue()?.ltCostPrice
    const gtCostPrice: any = popoverForm.getFieldsValue()?.gtCostPrice
    const eqCostPrice: any = popoverForm.getFieldsValue()?.eqCostPrice
    const complexPrice: any = popoverForm.getFieldsValue()?.complexPrice
    
    const overLimitPrice: any = popoverForm.getFieldsValue()?.overLimitPrice
    const lastUpdateTime: any = popoverForm.getFieldsValue()?.lastUpdateTime
    const lastUpdateTimeStart = lastUpdateTime?.[0]
      ? lastUpdateTime?.[0]?.format(DateTimeFormatSimpleOnlyOne)
      : undefined
    const lastUpdateTimeEnd = lastUpdateTime?.[1]
      ? lastUpdateTime?.[1]?.format(DateTimeFormatSimpleOnlyOne)
      : undefined
    const data = {
      ...dataParams,
      ...form.getFieldsValue(),
      materialsCategoryList: category,
      materialsCategory: Array.isArray(category) ? category?.[0] : undefined,
      category: Array.isArray(category) ? category?.[1] : undefined,
      current: 1,
      ...popoverForm.getFieldsValue(),
      lastUpdateTimeStart,
      lastUpdateTimeEnd,
      lastUpdateTime: undefined,
      chrgitmLvs: popoverForm.getFieldsValue()?.chrgitmLvs
        ? popoverForm.getFieldsValue()?.chrgitmLvs?.join(',')
        : '',
      anaesthesiaTag: popoverForm.getFieldsValue()?.anaesthesiaTag
        ? Number(popoverForm.getFieldsValue()?.anaesthesiaTag)
        : null,
      antibioticTag: popoverForm.getFieldsValue()?.antibioticTag
        ? Number(popoverForm.getFieldsValue()?.antibioticTag)
        : null,
      basicMedicineTag: popoverForm.getFieldsValue()?.basicMedicineTag
        ? Number(popoverForm.getFieldsValue()?.basicMedicineTag)
        : null,
      natNegoDrugFlag: popoverForm.getFieldsValue()?.natNegoDrugFlag
        ? Number(popoverForm.getFieldsValue()?.natNegoDrugFlag)
        : null,
      provinceTendFlag: popoverForm.getFieldsValue()?.provinceTendFlag
        ? Number(popoverForm.getFieldsValue()?.provinceTendFlag)
        : null,
      showFlag:
        showFlagValue?.join(',') == '0,1' || showFlagValue?.join(',') == '1,0'
          ? 1
          : showFlagValue?.join(',') == '0'
            ? 0
            : showFlagValue?.join(',') == '1'
              ? 2
              : '',
      isLimitPrice:
        isLimitPriceValue?.join(',') == '0,1' || isLimitPriceValue?.join(',') == '1,0'
          ? 2
          : isLimitPriceValue?.join(',') == '0'
            ? 0
            : isLimitPriceValue?.join(',') == '1'
              ? 1
              : '',
      gtPrice: gtPrice?.[0] == 1 ? 1 : 0,
      ltPrice: ltPrice?.[0] == 1 ? 1 : 0,
      eqPrice: eqPrice?.[0] == 1 ? 1 : 0,
      ltCostPrice: ltCostPrice?.[0] == 1 ? 1 : 0,
      gtCostPrice: gtCostPrice?.[0] == 1 ? 1 : 0,
      eqCostPrice: eqCostPrice?.[0] == 1 ? 1 : 0,
      complexPrice: complexPrice?.[0] == 1 ? 1 : 0,
    }
    props.onValueChange(data)
  }

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(values) => {
        props.onValueChange({
          ...dataParams,
          ...values,
          current: dataParams.current || 1,
        })
      }}
      initialValues={{
        state: 1,
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='allStr' noStyle>
            <Input
              size='middle'
              placeholder='搜索关键词'
              allowClear
              prefix={<SearchOutlined />}
              onChange={refresh}
            />
          </Form.Item>
          {/* <Col span={3}>
          <Form.Item name='approveFlg'>
            <Select
              placeholder='医保状态'
              allowClear
              dropdownClassName={styles.select}
              suffixIcon={<CaretDownFilled />}
              onChange={refresh}
            >
              <Option value='0'>未上传</Option>
              <Option value='-1'>审批未通过 </Option>
              <Option value='1'>审批已通过</Option>
              <Option value='2'>已上传待审批</Option>
            </Select>
          </Form.Item>
        </Col> */}
          <Form.Item name='materialsCategory' noStyle>
            <Cascader
              options={treeData}
              onChange={(v: any) => {
                refresh()
              }}
              changeOnSelect
              placeholder='商品类别'
            />
            {/* <TreeSelect
              placeholder="商品类别"
              allowClear
              onChange={refresh}
            >
              {
                treeData.length && treeData.map((v: any, index: number) => (
                  <TreeNode value={v.id} title={v.title} key={v.id}>
                    {
                      !!v.children.length && v.children.map((el: any) => (
                        <TreeNode value={el.id} title={el.title} key={el.id} />
                      ))
                    }
                  </TreeNode>))
              }
            </TreeSelect> */}
          </Form.Item>
          <Form.Item name='allMaterials' noStyle>
            <Select
              placeholder='药品范围'
              allowClear
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={refresh}
            >
              <Option value='0'>兴奋剂</Option>
              <Option value='1'>麻黄碱</Option>
              <Option value='2'>抗生素</Option>
              <Option value='3'>基药</Option>
            </Select>
          </Form.Item>
          <Form.Item name='tenantSupplierId' noStyle>
            <Select
              placeholder='生产厂家'
              allowClear
              showSearch
              onChange={refresh}
              optionFilterProp='children'
              // suffixIcon={<CaretDownFilled />}
              dropdownClassName={styles.select}
              onSearch={(v: any) => {
                dispatch(
                  pageSupplier({ name: v, supplierCategory: 1, size: 20 })
                )
              }}
            >
              {data.map((v: any, i) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.companyName}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='state' noStyle>
            <Select
              placeholder='状态'
              // defaultValue={1}
              onChange={refresh}
            // suffixIcon={<CaretDownFilled />}
            >
              <Option value={0}>注销</Option>
              <Option value={1}>启用</Option>
            </Select>
          </Form.Item>
          <Form.Item name='otc' noStyle>
            <Select
              placeholder='OTC'
              allowClear
              onChange={refresh}
            // suffixIcon={<CaretDownFilled />}
            >
              {OtcCategories.map((v) => {
                return (
                  <Option value={v} key={v}>
                    {getOtcCategoryName(v)}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          {insuranceArray.length !== 0 && (
            <>
              <Form.Item name='insuranceCode' noStyle>
                <Select
                  placeholder='医保险种'
                  // suffixIcon={<CaretDownFilled />}
                  // value={insuranceArray[0]}
                  onChange={refresh}
                >
                  {insuranceArray.map((v) => {
                    return (
                      <Option value={v.insuranceCode} key={v.id}>
                        {v.insuranceName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
              {tenantName?.indexOf('余姚健齿口腔诊所有限公司') < 0 &&
                tenantName?.indexOf('余姚康民内科诊所') < 0 &&
                tenantName?.indexOf('宁波鄞州青木堂中医诊所') < 0 &&
                tenantName?.indexOf('宁波鄞州德益内科诊所有限公司') < 0 &&
                tenantName?.indexOf('宁波鄞州毅康内科诊所有限公司') < 0 && (
                  <Form.Item name='isMapping' noStyle>
                    <Select
                      placeholder='匹配状态'
                      allowClear
                      onChange={refresh}
                    // style={{ width: '100px' }}
                    // suffixIcon={<CaretDownFilled />}
                    >
                      <Option value='0'>未匹配</Option>
                      <Option value='1'>未上传</Option>
                      <Option value='2'>已上传</Option>
                    </Select>
                  </Form.Item>
                )}
            </>
          )}
          <Popover
            visible={open}
            overlayClassName={styles.formQueryPopover}
            content={
              <>
                <Form
                  form={popoverForm}
                  onFinish={(val) => {
                    refresh()
                    setOpen(false)
                  }}
                >
                  <Row>
                    <Col
                      style={{
                        margin: '4px 0 0 0 ',
                        width: '70px',
                        textAlign: 'right',
                      }}
                    >
                      等级：
                    </Col>
                    <Col>
                      <Form.Item label='' name='chrgitmLvs'>
                        <Checkbox.Group>
                          <Checkbox value={'01'}>甲</Checkbox>
                          <Checkbox value={'02'}>乙</Checkbox>
                          <Checkbox value={'03'}>丙</Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className={styles.checkboxRow}>
                    <Col
                      style={{
                        margin: '4px 0 0 0 ',
                        width: '70px',
                        textAlign: 'right',
                      }}
                    >
                      药品范围：
                    </Col>
                    <div style={{width:'80px'}}>
                      <Form.Item
                        label=''
                        name='natNegoDrugFlag'
                        valuePropName='checked'
                      >
                        <Checkbox>国谈药</Checkbox>
                      </Form.Item>
                    </div>
                    <div style={{width:'80px'}}>
                      <Form.Item
                        label=''
                        name='provinceTendFlag'
                        valuePropName='checked'
                      >
                        <Checkbox>省招药</Checkbox>
                      </Form.Item>
                    </div>
                     <div style={{width:'80px'}}>
                      <Form.Item
                        label=''
                        name='antibioticTag'
                        valuePropName='checked'
                      >
                        <Checkbox>抗生素</Checkbox>
                      </Form.Item>
                    </div>
                     <div style={{width:'80px'}}>
                      <Form.Item
                        label=''
                        name='basicMedicineTag'
                        valuePropName='checked'
                      >
                        <Checkbox>基药</Checkbox>
                      </Form.Item>
                    </div>
                     <div style={{width:'80px'}}>
                      <Form.Item
                        label=''
                        name='anaesthesiaTag'
                        valuePropName='checked'
                      >
                        <Checkbox>毒麻类</Checkbox>
                      </Form.Item>
                    </div>
                  </Row>
                  <Row>
                    <Col
                      style={{
                        margin: '4px 0 0 0 ',
                        width: '70px',
                        textAlign: 'right',
                      }}
                    >
                      库存：
                    </Col>
                    <Col>
                      <Form.Item label='' name='showFlag'>
                        <Checkbox.Group>
                          <Checkbox value={'0'}>有库存</Checkbox>
                          <Checkbox value={'1'}>零库存</Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      style={{
                        margin: '4px 0 0 0 ',
                        width: '70px',
                        textAlign: 'right',
                      }}
                    >
                      零售价：
                    </Col>
                    <Form.Item label='' name='gtPrice'>
                      <Checkbox.Group style={{width:'120px'}}>
                        <Checkbox value={'1'}>超医保限价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                    <Form.Item label='' name='ltPrice'>
                      <Checkbox.Group style={{width:'120px'}}>
                        <Checkbox value={'1'}>低于医保限价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                    <Form.Item label='' name='eqPrice'>
                      <Checkbox.Group style={{width:'120px'}}>
                        <Checkbox value={'1'}>等于医保限价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Row>
                  <Row>
                    <Col
                      style={{
                        width: '70px',
                      }}
                    >
                    </Col>
                    <Form.Item label='' name='ltCostPrice'>
                      <Checkbox.Group style={{width:'120px'}}>
                        <Checkbox value={'1'}>低于进价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                    <Form.Item label='' name='gtCostPrice'>
                      <Checkbox.Group style={{width:'120px'}}>
                        <Checkbox value={'1'}>高于进价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                    <Form.Item label='' name='eqCostPrice'>
                      <Checkbox.Group style={{width:'120px'}}>
                        <Checkbox value={'1'}>等于进价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Row>
                   <Row>
                    <Col
                      style={{
                        width: '70px',
                      }}
                    >
                    </Col>
                    <Form.Item label='' name='complexPrice'>
                      <Checkbox.Group>
                        <Checkbox value={'1'}>售价和支付标准在40元及以上且高于实际进价150% </Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Row>
                  <Row>
                    <Col
                      style={{
                        margin: '4px 0 0 0 ',
                        width: '70px',
                        textAlign: 'right',
                      }}
                    >
                      医保限价：
                    </Col>
                    <Col>
                      <Form.Item label='' name='isLimitPrice'>
                        <Checkbox.Group>
                          <Checkbox value={'1'}>限价</Checkbox>
                          <Checkbox value={'0'}>不限价</Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      style={{
                        margin: '4px 0 0 0 ',
                        width: '128px',
                        textAlign: 'right',
                      }}
                    >
                      最近一次修改时间：
                    </Col>
                    <Col flex={1}>
                      <Form.Item label='' name='lastUpdateTime'>
                        <RangePicker
                          style={{ width: '330px' }}
                          format={DateTimeFormatSimpleOnlyOne}
                          showTime
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      height: '1px',
                      background: '#f0f0f0',
                      marginTop: '10px',
                    }}
                  ></Row>
                  <Space
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      marginTop: '10px',
                    }}
                  >
                    <Button
                      size='middle'
                      type={'ghost'}
                      onClick={() => {
                        setOpen(false)
                      }}
                    >
                      取消
                    </Button>
                    <Button size='middle' type='primary' htmlType='submit'>
                      确定
                    </Button>
                  </Space>
                </Form>
              </>
            }
            title=''
            trigger='click'
            placement='bottom'
          >
            <Form.Item name='' initialValue={'筛选'} noStyle>
              <Button
                style={{
                  color: theme.tc2,
                  width: '78px',
                  textAlign: 'left',
                  // overflow: 'hidden',
                  // textOverflow: 'ellipsis',
                }}
                icon={
                  <FilterIconOutlined
                    style={{
                      width: '14px',
                      height: '14px',
                      position: 'relative',
                      top: 2,
                      left: -2,
                      color: '#666',
                    }}
                  />
                }
                onClick={() => {
                  setOpen(true)
                }}
              >
                筛选
              </Button>
            </Form.Item>
          </Popover>
          <Button onClick={refresh} type='primary' style={{ float: 'right' }} loading={props?.loading}>
            查询
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
